import { render, staticRenderFns } from "./WangEditor.vue?vue&type=template&id=9acb214a&scoped=true"
import script from "./WangEditor.vue?vue&type=script&lang=js"
export * from "./WangEditor.vue?vue&type=script&lang=js"
import style0 from "./WangEditor.vue?vue&type=style&index=0&id=9acb214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9acb214a",
  null
  
)

export default component.exports